import Image, { type ImageProps } from "next/image"
import { Fragment } from "react"
import { twMerge } from "tailwind-merge"
import { BASE_PATH } from "@/constants/app.mjs"

interface LogoImageProps extends Omit<ImageProps, "src" | "alt"> {
  logoId: string
  alt: string
}

export function LogoImage({ logoId, alt, className, ...imageProps }: LogoImageProps) {
  const basePath = `${BASE_PATH}/static/images/marketing/home/logos/`
  const srcLight = `${basePath}${logoId}-grayscale-on-light.svg`
  const srcDark = `${basePath}${logoId}-grayscale-on-dark.svg`

  return (
    <Fragment>
      <Image
        {...imageProps}
        src={srcLight}
        alt={alt}
        className={twMerge("block dark:hidden", className)}
      />
      <Image
        {...imageProps}
        src={srcDark}
        alt={alt}
        className={twMerge("hidden dark:block", className)}
      />
    </Fragment>
  )
}
